import React from 'react'
import './Profile.css'
import PropTypes from 'prop-types'
import moment from 'moment'
//Bootstrap
import Form from 'react-bootstrap/Form'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
//Redux
import { useSelector } from 'react-redux'

function SignerModal(props) {
  const { show, handleClose } = props
  const profile = useSelector((state) => state.profile)

  let signerModalMarkup = profile.profile ? (
    <Modal show={show} onHide={handleClose} size='lg'>
      <Modal.Header closeButton>
        <Modal.Title className='signer-modal-style '>
          <div className='signer-modal-image '>
            <img src={profile.profile.image.url} alt='profile' width='100%' height='100%' />
          </div>
          <div className='signer-modal-name '>
            {profile.profile.title} {profile.profile.name}
          </div>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          <Form.Group controlId='formEmail' as={Row}>
            <Form.Label column sm='1'>
              Email
            </Form.Label>
            <Col sm='11'>
              <Form.Control readOnly defaultValue={profile.profile.email} />
            </Col>
          </Form.Group>

          <Form.Group controlId='formPhone' as={Row}>
            <Form.Label column sm='1'>
              Phone
            </Form.Label>
            <Col sm='11'>
              <Form.Control readOnly defaultValue={profile.profile.hpNumber} />
            </Col>
          </Form.Group>

          <Form.Group controlId='formTitle' as={Row}>
            <Form.Label column sm='1'>
              Position
            </Form.Label>
            <Col sm='11'>
              <Form.Control readOnly defaultValue={profile.profile.position} />
            </Col>
          </Form.Group>

          <Form.Group controlId='formStatus' as={Row}>
            <Form.Label column sm='1'>
              Location
            </Form.Label>
            <Col sm='11'>
              <Form.Control readOnly defaultValue={profile.profile.location} />
            </Col>
          </Form.Group>

          <Form.Label>
            Last online on
            {moment(profile.profile.lastOnlineTimestamp).calendar()}
          </Form.Label>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='primary' onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  ) : null

  return signerModalMarkup
}

SignerModal.propTypes = {
  show: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
}

export default SignerModal
